import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './AnnotationPagination.scss';

const BdsIcon = 'bds-icon' as any;

export interface AnnotationPaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

export const AnnotationPagination: React.FC<AnnotationPaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handlePageSelect = (page: number) => {
    onPageChange(page);
    setIsDropdownOpen(false);
  };

  const pageOptions = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="ann-pagination">
      <div className="ann-pagination__btn-wrap">
        <button
          type="button"
          className="ann-pagination__btn"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(1)}
        >
          <BdsIcon name="arrow-first" theme="outline" />
        </button>
      </div>

      <div className="ann-pagination__btn-wrap">
        <button
          type="button"
          className="ann-pagination__btn"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <BdsIcon name="arrow-left" theme="outline" />
        </button>
      </div>

      <div className="ann-pagination__select-wrap" ref={dropdownRef}>
        <button
          type="button"
          className="ann-pagination__select-btn"
          onClick={() => setIsDropdownOpen((prev) => !prev)}
        >
          <span>{currentPage}</span>
          <BdsIcon name="arrow-down" theme="outline" />
        </button>

        {isDropdownOpen && (
          <ul className="ann-pagination__dropdown">
            {pageOptions.map((page) => (
              <li key={page}>
                <button
                  type="button"
                  onClick={() => handlePageSelect(page)}
                >
                  {page}
                </button>
              </li>
            ))}
          </ul>
        )}

        <span className="ann-pagination__total">
          {t('sortBy.submenu.annotationHistory.paginationTotal', { totalPages })}
        </span>
      </div>

      <div className="ann-pagination__btn-wrap">
        <button
          type="button"
          className="ann-pagination__btn"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <BdsIcon name="arrow-right" theme="outline" />
        </button>
      </div>

      <div className="ann-pagination__btn-wrap">
        <button
          type="button"
          className="ann-pagination__btn"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          <BdsIcon name="arrow-last" theme="outline" />
        </button>
      </div>
    </div>
  );
};